import React from 'react'
import {
    BsCalculatorFill,
    BsCashStack,
    BsCheckCircleFill,
    BsClock,
    BsGiftFill,
    BsHeartFill,
    BsLockFill,
    BsPersonCheck,
    BsSearch,
    BsXCircle
} from 'react-icons/bs'
import {IoHelp} from 'react-icons/io5'
import {MdOutlineWifi} from 'react-icons/md'
import {HiOutlineComputerDesktop} from 'react-icons/hi2'
import {BiSolidSchool} from 'react-icons/bi'
import _ from "lodash"
import formatCurrency from "../../Billing/components/formatCurrency"

export const CourseActionTypes = Object.freeze({
    REGISTER: 'register',
    COURSE_CREATE: 'course-create',
    COURSE_UPDATE: 'course-update',
    COURSE_COPY: 'course-copy',
    COURSE_PROMOTE: 'course-promote',
    COURSE_DELETE: 'course-delete',
    ENROLLMENT_CREATE: 'enrollment-create',
    ENROLLMENT_DELETE: 'enrollment-delete',
    ENROLLMENT_REJECT: 'enrollment-reject',
    ENROLLMENT_APPROVE: 'enrollment-approve',
    ENROLLMENT_REVIEW: 'enrollment-review',
    SHOW_CLASS_LIST_MODAL: 'show-class-list-modal',
    SHOW_SUBJECT_LIST_MODAL: 'show-subject-list-modal',
    SHOW_TEACHER_LIST_MODAL: 'show-teacher-list-modal',
    SHOW_ENROLLMENT_REGISTER_MODAL: 'show-enrollment-modal',
})

export const ClassActionTypes = Object.freeze({
    CLASS_CREATE: 'class-create',
    CLASS_UPDATE: 'class-update',
    CLASS_DELETE: 'class-delete',
    SHOW_SUBJECT_LIST_MODAL: 'show-subject-list-modal',
    SHOW_STUDENT_LIST_MODAL: 'show-student-list-modal',
    SHOW_TEACHER_LIST_MODAL: 'show-teacher-list-modal',
    SHOW_TIMETABLE_LIST_MODAL: 'show-timetable-list-modal',
})

export const StudentActionTypes = Object.freeze({
    STUDENT_CREATE: 'student-create',
    STUDENT_UPDATE: 'student-update',
    STUDENT_DISABLE: 'student-disable',
    STUDENT_ACTIVE: 'student-active',
    STUDENT_DELETE: 'student-delete',
    STUDENT_DETAIL: 'student-detail',
    STUDENT_MOVE: 'student-move',
    STUDENT_REVOKE: 'student-revoke',
    STUDENT_ASSIGN: 'student-assign',
    STUDENT_IN_COURSE_UPDATE: 'student-in-course-update',
    STUDENT_IN_CLASS_UPDATE: 'student-in-class-update',
    STUDENT_ATTENDANCE_TRACKING: 'student-attendance-tracking',
    STUDENT_SUBJECT_SCORE_SUMMARY: 'student-subject-score-summary',
    STUDENT_AWARDING_MEDAL: 'student-awarding-medal',
    STUDENT_REVOKE_MEDAL: 'student-REVOKE-medal',
})

export const TeacherActionTypes = Object.freeze({
    TEACHER_CREATE: 'teacher-create',
    TEACHER_UPDATE: 'teacher-update',
    TEACHER_DELETE: 'teacher-delete',
    TEACHER_DISABLE: 'teacher-disable',
    TEACHER_ACTIVE: 'teacher-active',
    TEACHER_READ: 'teacher-read',
})

export const TimetableActionTypes = Object.freeze({
    TIMETABLE_CREATE: 'timetable-create',
    TIMETABLE_UPDATE: 'timetable-update',
    TIMETABLE_DUPLICATE: 'timetable-copy',
    TIMETABLE_DELETE: 'timetable-delete',
    TIMETABLE_READ: 'timetable-read',
})

export const SubjectActionTypes = Object.freeze({
    SUBJECT_CREATE: 'subject-create',
    SUBJECT_UPDATE: 'subject-update',
    SUBJECT_DELETE: 'subject-delete',
    SUBJECT_READ: 'subject-read',
})

export const CurriculumActionTypes = Object.freeze({
    CURRICULUM_CREATE: 'curriculum-create',
    CURRICULUM_UPDATE: 'curriculum-update',
    CURRICULUM_DELETE: 'curriculum-delete',
    CURRICULUM_READ: 'curriculum-read',
    CURRICULUM_LINK_SUBJECT: 'curriculum-link-subject',
    CURRICULUM_UNLINK_SUBJECT: 'curriculum-unlink-subject',
    CURRICULUM_CREATE_COURSE: 'curriculum-create-course',
})

export const GradeActionTypes = Object.freeze({
    GRADE_CREATE: 'grade-create',
    GRADE_UPDATE: 'grade-update',
    GRADE_DELETE: 'grade-delete',
    GRADE_DETAIL: 'grade-detail',
    GRADE_HISTORY: 'grade-history',
    COURSE_CLASS_EXAM_UPDATE: 'course-class-exam-update',
    VIEW_BY_SUBJECT_FILTER: 'view-by-subject-filter',
    GRADE_ADD_PARTICIPANT: 'grade-add-participant',
})

export const AttendanceActionTypes = Object.freeze({
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    DETAIL: 'detail',
    VIEW_BY_SUBJECT_FILTER: 'view-by-subject-filter',
})

export const AnnouncementActionTypes = Object.freeze({
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    DETAIL: 'detail',
})

export const grade_score_types = {
    text: {
        label: 'text',
        value: 'text',
    },
    number: {
        label: 'number',
        value: 'number',
    },
}

// label 'active'/'close' - dùng CHUNG cho cả Select "Trạng thái" ở form Tạo/Sửa Khóa (
// CourseSettingOverview.js/CourseSetForm.js, admin TỰ chọn thẳng 1/9) LẪN chip filter (CourseFilter.
// js) - giữ nguyên nhãn chung ở đây, KHÔNG đổi (25+ chỗ khác trong app cũng dùng đúng 2 key i18n
// 'active'/'close' này). Riêng ở chip filter, BE (CourseController::getCourses()) giờ kết hợp thêm
// điều kiện "còn hạn" khi lọc status=1 - CourseFilter.js tự đặt nhãn RIÊNG cho ngữ cảnh filter, xem
// recordStatusFilterLabels ở đó, không đụng tới label chung này.
export const course_status_options = {
    normal: {
        value: 1,
        label: 'active',
    },
    closed: {
        value: 9,
        label: 'close',
    },
}

// course_state (KHÁC course_status_options ở trên - đó là field status thô 1/9, còn đây là trạng
// thái TÍNH TOÁN theo ngày, khớp đúng Course::getCourseState() (BE) đã dùng để hiện badge ở
// CourseBanner.js/renderCourseSearchViewItem.js) - dùng làm preset chip filter cho CourseSearchFilter.js
// (course_fetchItems_Api?course_state=..., đơn chọn, thay cho toggle is_not_expired cũ chỉ có 2 mức
// đang/đã đóng - bạn yêu cầu tách riêng "đang chiêu sinh" khỏi "đang diễn ra").
export const course_state_options = {
    enrollment_open: {
        value: 'enrollment_open',
        label: 'enrollment open',
        icon: <BsCheckCircleFill size={12}/>,
        className: 'text-green-600',
    },
    in_process: {
        value: 'in_process',
        label: 'opening',
        icon: <BsClock size={12}/>,
        className: 'text-blue-600',
    },
    completed: {
        value: 'completed',
        label: 'closed',
        icon: <BsXCircle size={12}/>,
        className: 'text-color-400',
    },
}

export const attendance_status_options = {
    reset: {
        value: 0,
        label: 'undefined',
        className: 'text-color-500',
    },
    late: {
        value: -3,
        label: 'late',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-blue-500',
    },
    absent: {
        value: -2,
        label: 'unexcused absence',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-red-500',
    },
    absent_reason: {
        value: -1,
        label: 'excused absence',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-orange-500',
    },
    present: {
        value: 1,
        label: 'in attendance',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-green-600',
    },
}

export const enrollment_pipeline_status = {
    PENDING: -1,
    IDENTITY_REVIEW: 1,
    READY_FOR_CLASS: 2,
    COMPLETED: 9,
    REJECTED: -2,
}

export const enrollment_status_options = {
    pending: {
        value: -1,
        label: 'pending',
        icon: <BsClock size={11}/>,
        className: 'text-blue-500',
    },
    identity_review: {
        value: 1,
        label: 'identity review',
        icon: <BsSearch size={11}/>,
        className: 'text-purple-500',
    },
    ready_for_class: {
        value: 2,
        label: 'ready for class',
        icon: <BsPersonCheck size={11}/>,
        className: 'text-orange-500',
    },
    completed: {
        value: 9,
        label: 'enrollment completed',
        icon: <BsCheckCircleFill size={11}/>,
        className: 'text-green-600',
    },
    rejected: {
        value: -2,
        label: 'rejected',
        icon: <BsXCircle size={11}/>,
        className: 'text-red-500',
    },
}

// Hình thức giảng dạy - thuộc tính mới của Course (khớp Course::DELIVERY_MODE_* BE, migration
// 2026_08_26_000001_add_delivery_mode_and_fee_fields_to_courses), dùng cho form tạo/sửa khóa học
// (CourseSetForm.js), card + filter ở /edu (renderCourseSearchViewItem.js, CourseSearchFilter.js).
export const course_delivery_mode_options = {
    offline: {
        value: 1,
        label: 'offline',
        icon: <BiSolidSchool size={12}/>,
        className: 'text-orange-600',
    },
    online: {
        value: 2,
        label: 'online',
        icon: <MdOutlineWifi size={12}/>,
        className: 'text-blue-600',
    },
    hybrid: {
        value: 3,
        label: 'hybrid',
        icon: <HiOutlineComputerDesktop size={12}/>,
        className: 'text-purple-600',
    },
}

// Loại tiền tệ cho học phí (fee_currency_code) - hệ thống hiện chưa nơi nào thật sự hỗ trợ
// multi-currency (Channel/Account/UserBilling... đều validate cứng 'VND'), riêng học phí khóa học
// cho phép chọn thật giữa VND/USD theo yêu cầu (khóa học có thể mở cho học viên hải ngoại).
export const course_fee_currency_options = {
    vnd: {
        value: 'VND',
        label: 'VND (₫)',
    },
    usd: {
        value: 'USD',
        label: 'USD ($)',
    },
}

// Trạng thái học phí (fee_mode) - cột riêng trên Course, KHÔNG còn suy từ fee_amount===0 (không
// phân biệt được "miễn phí" và "tùy tâm đóng góp" - cả 2 đều không có mức cố định), khớp
// Course::FEE_MODE_* (BE), xem database/sql/096_add_fee_mode_to_courses.sql. Dùng cho form tạo/sửa
// khóa học (CourseSetForm.js) và chip filter (CourseSearchFilter.js) - mirror pattern
// course_delivery_mode_options ở trên.
export const course_fee_mode_options = {
    free: {
        value: 1,
        label: 'free',
        icon: <BsGiftFill size={12}/>,
        className: 'text-green-600',
    },
    paid: {
        value: 2,
        label: 'paid',
        icon: <BsCashStack size={12}/>,
        className: 'text-blue-600',
    },
    donation: {
        value: 3,
        label: 'donation based',
        icon: <BsHeartFill size={12}/>,
        className: 'text-rose-500',
    },
}

// Cách tính học phí khi fee_mode=paid - khớp Course::FEE_STRUCTURE_TYPE_* (BE), xem
// database/sql/098_add_finance_fields_to_courses_and_course_students.sql. fixed = giữ nguyên
// fee_amount/fee_currency_code cố định (hành vi cũ). itemized = bỏ qua fee_amount, khai chi tiết
// định mức + tín chỉ ở tab "Tài Chính & Học Phí" (CourseFinanceDashboard.js) - form này chỉ cho
// CHỌN chế độ, không nhập số tiền tại đây khi ở chế độ itemized.
export const course_fee_structure_type_options = {
    fixed: {
        value: 1,
        label: 'fixed fee',
        icon: <BsLockFill size={12}/>,
        className: 'text-slate-600',
    },
    itemized: {
        value: 2,
        label: 'itemized fee',
        icon: <BsCalculatorFill size={12}/>,
        className: 'text-indigo-600',
    },
}

// Nhãn hiển thị trạng thái phí trên card/banner/dòng info - gộp 1 chỗ tránh lặp lại logic 3 nhánh
// (free/paid/donation) ở nhiều nơi (renderCourseSearchViewItem.js, CourseBanner.js,
// CourseClassOperations.js) - trước đây mỗi chỗ tự suy feeLabel từ fee_amount===0, giờ đọc thẳng
// fee_mode. freeLabelKey cho phép nơi gọi tự chọn độ dài câu chữ (badge chật hẹp dùng "free" ngắn,
// dòng info rộng rãi dùng "completely free" đầy đủ hơn) mà không lặp lại nhánh paid/donation.
export const getCourseFeeLabel = (item, t, {freeLabelKey = 'free'} = {}) => {
    const {fee_mode, fee_amount, fee_currency_code} = item ?? {}
    switch (fee_mode) {
        case course_fee_mode_options.donation.value:
            return t(course_fee_mode_options.donation.label)
        case course_fee_mode_options.paid.value:
            return formatCurrency(fee_amount, {style: 'currency', currency: fee_currency_code || 'VND'})
        case course_fee_mode_options.free.value:
        default:
            return t(freeLabelKey)
    }
}

export const getGradeScore = (item, time = 0) => {
    const {score_type} = item ?? {}
    let score_text = null;
    let score_number = null;
    switch (time) {
        case 1:
            score_text = _.get(item, 'score_1_text')
            score_number = _.get(item, 'score_1_number')
            break;
        case 2:
            score_text = _.get(item, 'score_2_text')
            score_number = _.get(item, 'score_2_number')
            break;
        default:
            score_text = _.get(item, 'score_text')
            score_number = _.get(item, 'score_number')
            break;
    }
    switch (score_type) {
        case grade_score_types.text.value:
            return score_text
        case grade_score_types.number.value:
            return score_number
        default:
            break
    }

    return null;
}
